import {
  sendPostRequest, sendPutRequest, sendDeleteRequest, sendGetRequest
} from '../requests';

type DoctorsProps = {
  id: number,
  firstName: string,
  lastName: string,
  externalId: string
}

type DoctorsParams = {
  page: string,
  per_page: string
}

const baseUrl = '/doctors';

export const getDoctors = (params: DoctorsParams) =>
  sendGetRequest(baseUrl, params);

export const addDoctor = (data: DoctorsProps) =>
  sendPostRequest(baseUrl, data);

export const updateDoctorById = (id: string, body: DoctorsProps) =>
  sendPutRequest(`${baseUrl}/${id}`, body);

export const deleteDoctorById = (id: number) =>
  sendDeleteRequest(`${baseUrl}/${id}`);
